export default "__VITE_ASSET__BZHM_ND7__"